import type * as api from '@gitbook/api-client';
import { getChangeRequestBranchId } from '@gitbook/app-hive';
import { HiveBranchProvider } from '@gitbook/hive-react';

/**
 * Provide the revision for a change request.
 */
export function WithChangeRequestRevision(props: {
    space: api.Space;
    changeRequest: api.ChangeRequest;
    children: React.ReactNode;
}) {
    const { space, changeRequest, children } = props;

    return (
        <HiveBranchProvider
            contentId={space.id}
            branchId={getChangeRequestBranchId(changeRequest.id)}
            readOnly={true}
        >
            {children}
        </HiveBranchProvider>
    );
}
